import { common } from "./common";
import { candidate } from "./candidate";
import { date } from "./date";
import { enums } from "./enums";
import { error } from "./error";
import { home } from "./home";
import { plan } from "./plan";
import { user } from "./user";
import { member } from "./member";
import { category } from "./category";
import { translate } from "./translate";
import { term } from "./term";
import { invoice } from "./invoice";
import { platform } from "./platform";
import { group } from "./group";
import { manufacturer } from "./manufacturer";
import { region } from "./region";
import { franchise } from "./franchise";
import { release } from "./release";
import { gender } from "./gender";
import { media } from "./media";
import { collection } from "./collection";
import { tag } from "./tag";
import { podcast } from "./podcast";
import { language as languages } from "./language";

export const language = {
    translations: {
        common,
        candidate,
        date,
        enums,
        error,
        home,
        plan,
        user,
        member,
        category,
        translate,
        term,
        invoice,
        platform,
        group,
        manufacturer,
        region,
        franchise,
        release,
        gender,
        media,
        collection,
        tag,
        podcast,
        language: languages,
    },
};